import React from "react";
import SafeIcon from "../../../common/SafeIcon";
import { FiDownload, FiEye, FiFileText, FiMoreHorizontal } from "react-icons/fi";

function formatSize(bytes) {
  if (!Number.isFinite(Number(bytes))) return "—";
  const value = Number(bytes);
  if (value < 1024) return `${value} B`;
  if (value < 1024 * 1024) return `${(value / 1024).toFixed(1)} KB`;
  return `${(value / (1024 * 1024)).toFixed(1)} MB`;
}

function label(value) {
  return String(value || "general").replaceAll("_", " ");
}

export default function ClientDocumentCard({
  document,
  uploader,
  onPreview,
  onDownload,
  onDetails,
  onArchive,
  canManage,
  busy,
}) {
  return (
    <article className="rounded-2xl border border-slate-200 bg-white p-4 shadow-sm">
      <div className="flex items-start gap-3">
        <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-violet-50 text-violet-700">
          <SafeIcon icon={FiFileText} className="text-xl" />
        </span>
        <div className="min-w-0 flex-1">
          <h3 className="break-all text-sm font-bold text-slate-900">{document.file_name}</h3>
          <p className="mt-1 text-xs capitalize text-slate-500">{label(document.category)} · {formatSize(document.file_size)}</p>
          <p className="mt-1 text-xs text-slate-400">{new Date(document.created_at).toLocaleDateString()} · {uploader}</p>
        </div>
      </div>
      <div className="mt-3 flex items-center justify-between gap-3">
        <span className={`rounded-full px-2.5 py-1 text-[10px] font-bold ${document.visibility === "shared_with_accountant" ? "bg-emerald-50 text-emerald-700" : "bg-slate-100 text-slate-600"}`}>
          {document.visibility === "shared_with_accountant" ? "Shared with accountant" : "Private"}
        </span>
        <div className="flex gap-1">
          <button type="button" title="Preview" onClick={() => onPreview(document)} className="rounded-lg p-2 text-slate-500 hover:bg-violet-50 hover:text-violet-700"><SafeIcon icon={FiEye} /></button>
          <button type="button" title="Download" disabled={busy} onClick={() => onDownload(document)} className="rounded-lg p-2 text-slate-500 hover:bg-slate-100 disabled:opacity-50"><SafeIcon icon={FiDownload} /></button>
          <button type="button" title="View details" onClick={() => onDetails(document)} className="rounded-lg p-2 text-slate-500 hover:bg-slate-100"><SafeIcon icon={FiMoreHorizontal} /></button>
          {canManage && <button type="button" title="Archive" disabled={busy} onClick={() => onArchive(document)} className="rounded-lg px-2 text-xs font-bold text-rose-600 hover:bg-rose-50 disabled:opacity-50">Archive</button>}
        </div>
      </div>
    </article>
  );
}